import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles"
import { RoomStyle } from "./RoomStyle";
import { ONLINE_STATUS } from "../../config";
import RoomParticipantList from "../../components/RoomParticipantList/RoomParticipantList";

const useStyles = makeStyles((theme) => RoomStyle(theme));

export default function RoomUserLobby({
  roomId,
  setSearchedRoomParticipants,
  roomParticipants,
  roomLoading,
  roomModerators,
}) {
  const classes = useStyles();
  const [onlineStatusFilter, setOnlineStatusFilter] = useState("all"); // Default filter is "all"
  const [filteredParticipants, setFilteredParticipants] = useState([]);

  useEffect(() => {
    // Apply online status filter
    let newFilteredParticipants = roomParticipants;

    if (onlineStatusFilter === ONLINE_STATUS.ONLINE) {
      newFilteredParticipants = roomParticipants.filter(
        (participant) => participant.is_online
      );
    } else if (onlineStatusFilter === ONLINE_STATUS.OFFLINE) {
      newFilteredParticipants = roomParticipants.filter(
        (participant) => !participant.is_online
      );
    } else {
      newFilteredParticipants = roomParticipants;
    }

    setFilteredParticipants(newFilteredParticipants);
  }, [onlineStatusFilter, roomParticipants]);

  const handleUserSearchChange = (e) => {
    setSearchedRoomParticipants(e.target.value);
  };

  const handleUserOnlineStatusChange = (e) => {
    const selectedFilter = e.target.value;
    setOnlineStatusFilter(selectedFilter);
  };

  return (
    <div>
      <div className={classes.textMiddle}></div>
      <div className={classes.textMiddle}>
        <input
          type="text"
          placeholder="Search user..."
          onChange={handleUserSearchChange}
          className={classes.searchBox}
        />
      </div>
      {/* <div className={classes.textMiddle}>
        <select
          value={onlineStatusFilter}
          onChange={handleUserOnlineStatusChange}
        >
          <option value="all">All</option>
          <option value={ONLINE_STATUS.ONLINE}>Online</option>
          <option value={ONLINE_STATUS.OFFLINE}>Offline</option>
        </select>
      </div> */}

      <RoomParticipantList
        classes={classes}
        roomParticipants={filteredParticipants}
        roomLoading={roomLoading}
        roomModerators={roomModerators}
        roomId={roomId}
        onlineStatusFilter={onlineStatusFilter}
      />
    </div>
  );
}
